<template>

  <v-card
    max-width="205"
  >
      <v-card-text class="justify-end mb-n4" style="font-size:1.0em" >
      Email With Error(s)
      </v-card-text>

      <v-card-text>
          <div class ="text-end font-weight-bold" style="font-size:1.0em">
            {{ with_errors }}
          </div>
      </v-card-text>

  </v-card>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'EmailWithErrors',
  computed: {
    ...mapGetters({
      with_errors: 'count_with_errors'
    })
  }
}
</script>
